module.exports = __webpack_public_path__ + "static/media/Sameer.00f75647.png";